/**
 * Barrel of every built-in theme manifest.
 *
 * The Theme_Engine consumes `ALL_MANIFESTS` to populate its registry.
 * Adding a theme is one new directory plus one entry in this barrel
 * (Requirement 8.3).
 *
 * Pure module: every imported manifest is a plain object literal with
 * no runtime side effects, and SVG art is loaded lazily via Vite
 * `?url` thunks so each theme's bytes land in a separate chunk
 * (Property 28 / Requirement 11.5).
 */

import { barbieManifest } from './barbie/manifest';
import { stellaManifest } from './stella/manifest';

export const ALL_MANIFESTS = [barbieManifest, stellaManifest] as const;

export { barbieManifest, stellaManifest };
